










































































































































































import { defineComponent, ref } from '@vue/composition-api';
import moment from 'moment';

import { ITariffException } from '@/models';
import {
  useFetchTariffExceptions,
  useDeleteTariffException
} from '@/composable/tariff-exceptions';
import authMixin from '@/mixins/auth';

import ALPage from '@/components/core/Page/ALPage.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import TariffExceptionFormDialog from '@/components/tariff/TariffExceptionFormDialog.vue';
import TariffExceptionUploadFileDialog from '@/components/tariff/TariffExceptionUploadFileDialog.vue';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export default defineComponent({
  name: 'TariffExceptionListPage',

  mixins: [authMixin],

  components: {
    ALPage,
    ConfirmationDialog,
    ErrorAlert,
    TariffExceptionFormDialog,
    TariffExceptionUploadFileDialog
  },

  setup(_) {
    //We use a separate ref for the search model in order to not update the queryKey once the search is updated
    const currentSearch = ref<string>('');

    const headers = [
      { text: '#', value: 'index', sortable: false, width: 5 },
      {
        text: 'Destination Country',
        value: 'destination_country',
        sortable: false
      },
      { text: 'Country of Origin', value: 'origin_country', sortable: false },
      { text: 'Item', value: 'item', sortable: false },
      { text: 'HS Code', value: 'hs_code', sortable: false },
      {
        text: 'Tariff Rate (%)',
        value: 'tariff_rate',
        width: 200,
        align: 'right',
        sortable: false
      },
      { text: '', value: 'actions', sortable: false, width: 100 }
    ];

    const dialog = ref(false);
    const selectedTariffException = ref<ITariffException | null>(null);

    function openTariffExceptionDialog(tariffException?: ITariffException) {
      dialog.value = true;
      selectedTariffException.value = tariffException ?? null;
    }

    const {
      isLoading: deleteInProgress,
      error: deleteError,
      mutate: deleteTariffException,
      reset: deleteReset
    } = useDeleteTariffException();

    const deleteDialog = ref(false);
    function openDeleteTariffExceptionDialog(
      tariffException: ITariffException
    ) {
      selectedTariffException.value = tariffException;
      deleteDialog.value = true;
    }

    function closeDrawerAndDialog() {
      drawer.value = false;
      deleteDialog.value = false;
    }

    function removeTariffException(vehicle: ITariffException) {
      deleteTariffException(vehicle.id!, {
        onSuccess: () => {
          closeDrawerAndDialog();
        }
      });
    }

    function clearAllErrors() {
      deleteReset();
      error.value = null;
    }

    const { tariffExceptions, error, isLoading } = useFetchTariffExceptions();

    const drawer = ref(false);
    function openTariffExceptionDrawer(tariffException: ITariffException) {
      selectedTariffException.value = tariffException;
      drawer.value = true;
    }

    return {
      deleteInProgress,
      deleteDialog,
      deleteError,
      drawer,
      selectedTariffException,
      moment,
      dialog,
      currentSearch,
      tariffExceptions,
      isLoading,
      headers,
      error,
      openTariffExceptionDialog,
      clearAllErrors,
      openDeleteTariffExceptionDialog,
      openTariffExceptionDrawer,
      closeDrawerAndDialog,
      removeTariffException
    };
  }
});
